"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import {
  Component,
  Mixins,
  Ref
} from "vue-property-decorator";
import { AccountSessionMixins } from "@/service/account-session";
import _ from "lodash";
import API from "@ym-framework/api-utils";
import Shops from "@/views/virtualdesktopItems/components/Shops.vue";
import ExtShops from "@/views/virtualdesktopItems/components/ExtShops.vue";
import DateFormat from "@/framework/timeformatter";
import OsElement from "@/views/virtualdesktopItems/components/OsElement.vue";
import VdAdminView from "@/views/virtualdesktopItems/components/VdAdminView.vue";
import ShopBindAdmin from "@/views/bindItems/ShopBindAdmin.vue";
import AddVisitDialog from "@/views/shopItems/components/AddVisitDialog.vue";
import StartupByShopBtn from "@/views/shopItems/components/StartupByShopBtn.vue";
import EditVdNameDialog from "@/views/virtualdesktopItems/components/dialog-forms/EditVdNameDialog.vue";
import VirtualdesktopForm from "@/views/virtualdesktopItems/components/dialog-forms/VirtualdesktopForm.vue";
import Question from "@/components/Question.vue";
import UiGrid, { GridController } from "@/components/grid/UiGrid.vue";
import { APIDataSource } from "@/components/grid/data-source";
import { UiConfirm } from "@/service/ConfirmBox/confirm";
import ShopOnline from "@/views/shopItems/components/ShopOnline.vue";
import { Debounce } from "vue-debounce-decorator";
import { WebsocketViewService } from "@/utils/webSocketViewService";
import BrowserProgressComponent from "@/components/progress/BrowserProgress.vue";
import { TimerEngine } from "@/utils/settimeout";
class OnlineList {
  constructor() {
    this.datas = [];
    this.total = 0;
  }
}
let VdSettingView = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.webSocketService = WebsocketViewService;
    this.browsernotify = null;
    this.waitingOpenShops = [];
    this.vdId = "";
    this.del_cookie = false;
    this.vdDetail = null;
    this.gridController = null;
    this.view_listener = null;
  }
  mounted() {
    return __async(this, null, function* () {
      var _a;
      this.webSocketService._ipcEvent.on(
        "event:virtualbrowser.download.start",
        (data) => __async(this, null, function* () {
          const h = this.$createElement;
          this.browsernotify = this.$notify({
            title: this.$t("homepage.browser.downloading"),
            dangerouslyUseHTMLString: true,
            duration: 0,
            message: h(BrowserProgressComponent)
          });
          let item = {
            shop_id: data.value.shop_id,
            vd_id: data.value.vd_id,
            new_vd: data.value.new_vd,
            new_shop_id: data.value.new_shop_id,
            launcher_value: data.value.launcher_value
          };
          this.waitingOpenShops.push(item);
        })
      );
      this.webSocketService._ipcEvent.on(
        "event:dynamicBrowser.download.complete",
        (data) => __async(this, null, function* () {
          setTimeout(() => __async(this, null, function* () {
            var _a2;
            this.browsernotify.close();
            this.browsernotify = null;
            for (const item of this.waitingOpenShops) {
              try {
                yield API.get(
                  `api://base.local/storages/preference/mainExtensionVersion`
                );
                yield API.post(`api://base.local/websockets/main`, {
                  model: "virtualBrowser.launcher_new",
                  value: {
                    shop_id: item.shop_id,
                    vd_id: item.vd_id,
                    new_vd: item.new_vd,
                    new_shop_id: item.new_shop_id,
                    launcher_value: item.launcher_value
                  }
                });
              } catch (error) {
                yield API.post(`api://base.local/websockets/main`, {
                  model: "virtualBrowser.launcher",
                  value: {
                    shop_id: item.shop_id,
                    vd_id: item.vd_id,
                    new_vd: item.new_vd,
                    new_shop_id: item.new_shop_id,
                    launcher_value: item.launcher_value
                  }
                });
              }
              const _item = _.find((_a2 = this.gridController) == null ? void 0 : _a2.result.datas, {
                shopOldId: item.shop_id
              });
              if (_item) {
                _item.btnState = "loading";
              }
            }
            this.waitingOpenShops = [];
          }), 800);
        })
      );
      this.webSocketService._ipcEvent.on(
        "event:virtualbrowser.launcher.restart",
        (data) => __async(this, null, function* () {
          var _a2;
          const _item = _.find((_a2 = this.gridController) == null ? void 0 : _a2.result.datas, {
            shopOldId: data.data.id
          });
          if (_item) {
            _item.btnState = "loading";
          }
        })
      );
      this.webSocketService._ipcEvent.on(
        "event:clientEvent.subBrowser.launch",
        (data) => __async(this, null, function* () {
          var _a2;
          const _item = _.find((_a2 = this.gridController) == null ? void 0 : _a2.result.datas, {
            shopOldId: data.data.id
          });
          if (_item) {
            const _timeout = setTimeout(() => {
              _item.btnState = "open";
            }, 1e3);
          }
        })
      );
      this.webSocketService._ipcEvent.on(
        "event:clientEvent.subBrowser.terminal",
        (data) => __async(this, null, function* () {
          var _a2;
          console.log(data);
          const _item = _.find((_a2 = this.gridController) == null ? void 0 : _a2.result.datas, {
            shopOldId: data.data.id
          });
          if (_item) {
            setTimeout(() => {
              _item.launcher_progress = 0;
              _item.btnState = "ready";
            }, 1e3);
          }
        })
      );
      this.webSocketService._ipcEvent.on(
        "event:clientEvent.dynamicBrowser.terminal",
        (data) => __async(this, null, function* () {
          var _a2;
          const _item = _.find((_a2 = this.gridController) == null ? void 0 : _a2.result.datas, {
            shopOldId: data.data.id
          });
          if (_item) {
            setTimeout(() => {
              _item.launcher_progress = 0;
              _item.btnState = "ready";
            }, 1e3);
          }
        })
      );
      this.webSocketService._ipcEvent.on(
        "event:clientEvent.subBrowser.launch.error",
        (data) => __async(this, null, function* () {
          yield this.manageError(data);
        })
      );
      this.webSocketService._ipcEvent.on(
        "event:clientEvent.subBrowser.launch.progress",
        (data) => __async(this, null, function* () {
          var _a2;
          const _item = _.find((_a2 = this.gridController) == null ? void 0 : _a2.result.datas, {
            shopOldId: data.data.id
          });
          if (_item) {
            _item.launcher_progress = data.data.progress;
            if (_item.launcher_progress === 100) {
              const _timeout = setTimeout(() => {
                _item.launcher_progress = 0;
                _item.btnState = "open";
              }, 1e3);
            }
          }
        })
      );
      this.vdId = this.$route.query.vd_id || "";
      if (this.vdId === void 0 || this.vdId === null || this.vdId === "") {
        this.goBack();
      }
      yield this.getVdDetail();
      this.gridController = new GridController(
        new APIDataSource(`api://base.auth.pro/v1/shops`)
      );
      this.gridController.query.params = {
        type: "SHOW",
        search: `vdId==${this.vdId}`
      };
      (_a = this.gridController) == null ? void 0 : _a.on("searched", (item) => __async(this, null, function* () {
        yield this.searched();
      }));
      this.gridController.pagePosition = "dialog";
      this.gridController.query.sort = "createdTime,desc";
      this.gridController.result.on("add.item", (item) => {
        item.set("launcher_progress", 0);
        item.set("remote_launcher_progress", 0);
        item.set("btnState", "ready");
        item.set("onLineList", new OnlineList());
        item.set("status", this.vdDetail.status);
        item.set("realAccount", item.get("account"));
      });
      yield this.gridController.search();
      yield this.getView();
    });
  }
  getView() {
    return __async(this, null, function* () {
      this.view_listener = new TimerEngine(() => __async(this, null, function* () {
        var _a, _b;
        try {
          let shop_ids = _.map((_a = this.gridController) == null ? void 0 : _a.result.datas, "shopOldId");
          let response = yield API.post(
            `api://base.auth.view/api/v1/online-users/shop`,
            {
              ids: shop_ids
            }
          );
          for (const _item of response.data.datas) {
            const _column = _.find((_b = this.gridController) == null ? void 0 : _b.result.datas, {
              shopOldId: _item.shopId
            });
            if (_column) {
              let _onLineList = {
                total: _item.users.length,
                datas: _item.users
              };
              _column.onLineList = _onLineList;
            }
          }
        } catch (error) {
        }
      }), 2e4);
      this.view_listener.start();
    });
  }
  //处理账号
  handleAccount(account) {
    if (account.indexOf("@") !== -1) {
      let arr = account.split("@");
      let front = arr[0];
      if (front.length > 4) {
        let new_account = front.substring(0, 2) + "***" + front.substring(front.length - 2, front.length) + "@" + arr[1];
        return new_account;
      } else {
        if (front.length === 1) {
          let new_account = front + "***@" + arr[1];
          return new_account;
        } else if (front.length === 2) {
          let new_account = front.substring(0, 1) + "***" + front.substring(front.length - 1, front.length) + "@" + arr[1];
          return new_account;
        } else {
          let new_account = front.substring(0, 2) + "***" + front.substring(front.length - 1, front.length) + "@" + arr[1];
          return new_account;
        }
      }
    } else {
      if (account.length > 4) {
        let new_account = account.substring(0, 2) + "***" + account.substring(account.length - 2, account.length);
        return new_account;
      } else {
        if (account.length === 1) {
          let new_account = account + "***";
          return new_account;
        } else if (account.length === 2) {
          let new_account = account.substring(0, 1) + "***" + account.substring(account.length - 1, account.length);
          return new_account;
        } else {
          let new_account = account.substring(0, 2) + "***" + account.substring(account.length - 1, account.length);
          return new_account;
        }
      }
    }
  }
  //VD APIS
  getVdDetail() {
    return __async(this, null, function* () {
      try {
        const response = yield API.get(
          `api://base.auth.pro/v1/virtual-desktops/${this.vdId}`
        );
        this.vdDetail = response.data;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  // 销毁前的调用
  beforeDestroy() {
    this.webSocketService._ipcEvent.removeAllListeners();
    if (this.view_listener !== null) {
      this.view_listener.stop();
    }
  }
  //
  searched() {
    return __async(this, null, function* () {
      var _a;
      try {
        const response = yield API.get(`api://base.local/v2/dynamic-browsers`);
        if (response.data.data && response.data.data.length > 0) {
          for (const item of (_a = this.gridController) == null ? void 0 : _a.result.datas) {
            let shop_data = item;
            for (const shopData of response.data.data) {
              if (shopData.id === shop_data.shopOldId) {
                item.btnState = "open";
              }
            }
          }
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  // 流量详情
  trafficDetail(item) {
    return __async(this, null, function* () {
      try {
        this.$router.push({
          path: "/traffic_detail",
          query: { vd_id: item.config.oldId }
        });
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  //为选中店铺分配管理员
  chooseAdmin(item) {
    return __async(this, null, function* () {
      try {
        const response = yield API.get(
          `api://base.auth.pro/v1/shop/${item.id}/auth-users`
        );
        let _list = _.map(response.data.datas, (data) => {
          return {
            // id: data.guid,
            id: data.id,
            label: `${data.name} (${data.number.toString().substring(
              data.number.toString().length - 4,
              data.number.toString().length
            )})`
          };
        });
        this._shopBindAdmin.open("single", [item], _list);
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  /**
   * 判断是否为cookie失效导致的错误
   * @param error 错误对象
   * @returns 是否为cookie失效
   */
  isCookieExpired(error) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
    if (((_a = error == null ? void 0 : error.response) == null ? void 0 : _a.status) === 401 || ((_b = error == null ? void 0 : error.response) == null ? void 0 : _b.status) === 403) {
      return true;
    }
    if (((_g = (_f = (_e = (_d = (_c = error == null ? void 0 : error.response) == null ? void 0 : _c.data) == null ? void 0 : _d.errors) == null ? void 0 : _e.datas) == null ? void 0 : _f[0]) == null ? void 0 : _g.code) === "token.error" || ((_j = (_i = (_h = error == null ? void 0 : error.errors) == null ? void 0 : _h.datas) == null ? void 0 : _i[0]) == null ? void 0 : _j.code) === "token.error") {
      return true;
    }
    if ((error == null ? void 0 : error.hasOwnProperty("response")) && (((_k = error.response) == null ? void 0 : _k.status) === 401 || ((_l = error.response) == null ? void 0 : _l.status) === 403)) {
      return true;
    }
    return false;
  }
  manageError(data) {
    return __async(this, null, function* () {
      var _a, _b, _c;
      const _item = _.find((_a = this.gridController) == null ? void 0 : _a.result.datas, {
        shopOldId: data.data.id
      });
      if (_item) {
        const _timeout = setTimeout(() => {
          _item.btnState = "ready";
        }, 1e3);
      }
      if (this.isCookieExpired(data.data.error)) {
        this.$message.error(
          this.$t("main.shop_launch_cookie_expired")
        );
        return;
      }
      if (data.data.error.hasOwnProperty("errors") && data.data.error.errors.datas[0].code === "lock.shop") {
        if (((_b = this.$session) == null ? void 0 : _b.type) === "user") {
          this.$message.error(this.$t("shop.user_lock_error_message"));
        }
      } else if (data.data.error.hasOwnProperty("errors") && data.data.error.errors.datas[0].code === "lock.vd") {
        if (((_c = this.$session) == null ? void 0 : _c.type) === "user" && !this.$session.permissions.is("SHOW_ALL_MENUS")) {
          this.$message.error(this.$t("vd.user_lock_error_message"));
        }
      } else if (data.data.error.hasOwnProperty("errors") && data.data.error.errors.datas[0].code === "browser") {
        let time = sessionStorage.getItem("browser_retry_times");
        if (time === null) {
          time = "1";
          sessionStorage.setItem("browser_retry_times", time);
          this.$message.info(
            this.$t("main.shop_launch_browser_error_info")
          );
          let env_response = yield API.get(
            `api://base.auth.pro/v1/shops/${data.data.new_shop_id}/environment`
          );
          let code = env_response.data.appData.browser.code;
          let version = env_response.data.appData.browser.version;
          yield API.delete(
            `api://base.local/v2/dynamic-browsers/private/brands/${code}/versions/${version}`
          );
          yield API.post(`api://base.local/websockets/view`, {
            model: "virtualbrowser.launcher.restart",
            value: {
              vd_guid: data.data.vd_id,
              shop_id: data.data.id,
              new_vd: data.data.new_vd,
              new_shop_id: data.data.new_shop_id
            }
          });
          try {
            yield API.get(
              `api://base.local/storages/preference/mainExtensionVersion`
            );
            yield API.post(`api://base.local/websockets/main`, {
              model: "virtualBrowser.launcher_new",
              value: {
                shop_id: data.data.id,
                vd_id: data.data.vd_id,
                new_vd: data.data.new_vd,
                new_shop_id: data.data.new_shop_id
              }
            });
          } catch (error) {
            yield API.post(`api://base.local/websockets/main`, {
              model: "virtualBrowser.launcher",
              value: {
                shop_id: data.data.id,
                vd_id: data.data.vd_id,
                new_vd: data.data.new_vd,
                new_shop_id: data.data.new_shop_id
              }
            });
          }
        } else if (time !== null && Number(time) < 3) {
          time = (Number(time) + 1).toString();
          sessionStorage.setItem("browser_retry_times", time);
          this.$message.info(
            this.$t("main.shop_launch_browser_error_info")
          );
          let env_response = yield API.get(
            `api://base.auth.pro/v1/shops/${data.data.new_shop_id}/environment`
          );
          let code = env_response.data.appData.browser.code;
          let version = env_response.data.appData.browser.version;
          yield API.delete(
            `api://base.local/v2/dynamic-browsers/private/brands/${code}/versions/${version}`
          );
          yield API.post(`api://base.local/websockets/view`, {
            model: "virtualbrowser.launcher.restart",
            value: {
              vd_guid: data.data.vd_id,
              shop_id: data.data.id,
              new_vd: data.data.new_vd,
              new_shop_id: data.data.new_shop_id
            }
          });
        } else {
          if (this.isCookieExpired(data.data.error)) {
            this.$message.error(
              this.$t("main.shop_launch_cookie_expired")
            );
          } else {
            this.$message.error(
              this.$t("main.shop_launch_browser_error_message")
            );
          }
        }
      } else if (data.data.error.hasOwnProperty("response")) {
        if (data.data.error.response.data.hasOwnProperty("errors") && data.data.error.response.data.errors.datas[0].code === "browser.resource.not.exist") {
          const h2 = this.$createElement;
          if (data.data.error.browser_core === "firefox") {
            yield UiConfirm.confirm(
              "",
              this.$t("main.shop_visit_browser_resorce_title"),
              {
                message: h2("div", void 0, [
                  h2(
                    "p",
                    void 0,
                    this.$t(
                      "main.shop_visit_browser_firefox_resorce_tip"
                    )
                  )
                ]),
                confirmButtonText: this.$t("main.confirm"),
                cancelButtonText: this.$t("main.cancel")
              }
            );
          } else if (data.data.error.browser_core === "chrome") {
            yield UiConfirm.confirm(
              "",
              this.$t("main.shop_visit_browser_resorce_title"),
              {
                message: h2("div", void 0, [
                  h2(
                    "p",
                    void 0,
                    this.$t(
                      "main.shop_visit_browser_chrome_resorce_tip"
                    )
                  )
                ]),
                confirmButtonText: this.$t("main.confirm"),
                cancelButtonText: this.$t("main.cancel")
              }
            );
          } else {
            yield UiConfirm.confirm(
              "",
              this.$t("main.shop_visit_browser_resorce_title"),
              {
                message: h2("div", void 0, [
                  h2(
                    "p",
                    void 0,
                    this.$t("main.shop_visit_browser_resorce_tip")
                  )
                ]),
                confirmButtonText: this.$t("main.confirm"),
                cancelButtonText: this.$t("main.cancel")
              }
            );
          }
        } else if (data.data.error.response.data.hasOwnProperty("errors") && data.data.error.response.data.errors.datas[0].code === "browser") {
          let time = sessionStorage.getItem("browser_retry_times");
          if (time === null) {
            time = "1";
            sessionStorage.setItem("browser_retry_times", time);
            this.$message.info(
              this.$t("main.shop_launch_browser_error_info")
            );
            let env_response = yield API.get(
              `api://base.auth.pro/v1/shops/${data.data.new_shop_id}/environment`
            );
            let code = env_response.data.appData.browser.code;
            let version = env_response.data.appData.browser.version;
            yield API.delete(
              `api://base.local/v2/dynamic-browsers/private/brands/${code}/versions/${version}`
            );
            yield API.post(`api://base.local/websockets/view`, {
              model: "virtualbrowser.launcher.restart",
              value: {
                vd_guid: data.data.vd_id,
                shop_id: data.data.id,
                new_vd: data.data.new_vd,
                new_shop_id: data.data.new_shop_id
              }
            });
            try {
              yield API.get(
                `api://base.local/storages/preference/mainExtensionVersion`
              );
              yield API.post(`api://base.local/websockets/main`, {
                model: "virtualBrowser.launcher_new",
                value: {
                  shop_id: data.data.id,
                  vd_id: data.data.vd_id,
                  new_vd: data.data.new_vd,
                  new_shop_id: data.data.new_shop_id
                }
              });
            } catch (error) {
              yield API.post(`api://base.local/websockets/main`, {
                model: "virtualBrowser.launcher",
                value: {
                  shop_id: data.data.id,
                  vd_id: data.data.vd_id,
                  new_vd: data.data.new_vd,
                  new_shop_id: data.data.new_shop_id
                }
              });
            }
          } else if (time !== null && Number(time) < 3) {
            time = (Number(time) + 1).toString();
            sessionStorage.setItem("browser_retry_times", time);
            this.$message.info(
              this.$t("main.shop_launch_browser_error_info")
            );
            let env_response = yield API.get(
              `api://base.auth.pro/v1/shops/${data.data.new_shop_id}/environment`
            );
            let code = env_response.data.appData.browser.code;
            let version = env_response.data.appData.browser.version;
            yield API.delete(
              `api://base.local/v2/dynamic-browsers/private/brands/${code}/versions/${version}`
            );
            yield API.post(`api://base.local/websockets/view`, {
              model: "virtualbrowser.launcher.restart",
              value: {
                vd_guid: data.data.vd_id,
                shop_id: data.data.id,
                new_vd: data.data.new_vd,
                new_shop_id: data.data.new_shop_id
              }
            });
          } else {
            if (this.isCookieExpired(data.data.error)) {
              this.$message.error(
                this.$t("main.shop_launch_cookie_expired")
              );
            } else {
              this.$message.error(
                this.$t("main.shop_launch_browser_error_message")
              );
            }
          }
        } else if (data.data.error.code === "ERR_BAD_REQUEST") {
          console.log(data);
          if (this.isCookieExpired(data.data.error)) {
            this.$message.error(
              this.$t("main.shop_launch_cookie_expired")
            );
          } else {
            this.$message.error(
              this.$t("main.shop_launch_browser_error_message")
            );
          }
        }
      } else if (data.data.error.hasOwnProperty("message") && data.data.error.message === "upgrade Browser Core") {
      } else if (data.data.error.code === "ERR_BAD_REQUEST") {
        console.log(data);
        let env_response = yield API.get(
          `api://base.auth.pro/v1/shops/${data.data.new_shop_id}/environment`
        );
        let code = env_response.data.appData.browser.code;
        let version = env_response.data.appData.browser.version;
        yield API.delete(
          `api://base.local/v2/dynamic-browsers/private/brands/${code}/versions/${version}`
        );
        let time = sessionStorage.getItem("browser_retry_times");
        if (time === null) {
          time = "1";
          sessionStorage.setItem("browser_retry_times", time);
          yield API.post(`api://base.local/websockets/view`, {
            model: "virtualbrowser.launcher.restart",
            value: {
              vd_guid: data.data.vd_id,
              shop_id: data.data.id,
              new_vd: data.data.new_vd,
              new_shop_id: data.data.new_shop_id
            }
          });
          try {
            yield API.get(
              `api://base.local/storages/preference/mainExtensionVersion`
            );
            yield API.post(`api://base.local/websockets/main`, {
              model: "virtualBrowser.launcher_new",
              value: {
                shop_id: data.data.id,
                vd_id: data.data.vd_id,
                new_vd: data.data.new_vd,
                new_shop_id: data.data.new_shop_id
              }
            });
          } catch (error) {
            yield API.post(`api://base.local/websockets/main`, {
              model: "virtualBrowser.launcher",
              value: {
                shop_id: data.data.id,
                vd_id: data.data.vd_id,
                new_vd: data.data.new_vd,
                new_shop_id: data.data.new_shop_id
              }
            });
          }
          this.$message.error(this.$t("main.shop_launcher_loading"));
        } else {
        }
      } else if (data.data.error.code === "ERR_DISK_ROOM_NOT_ENOUGH") {
        yield UiConfirm.warnconfirm(this.$t("main.shop_launcher_disk_room_not_enough"), this.$t("main.shop_launcher_disk_room_not_enough_title"), {
          confirmButtonText: this.$t("main.confirm"),
          showCancelButton: false,
          iconClass: "el-icon-warning"
        });
      } else {
        console.log(data);
        if (this.isCookieExpired(data.data.error)) {
          this.$message.error(
            this.$t("main.shop_launch_cookie_expired")
          );
        } else {
          this.$message.error(
            this.$t("main.shop_launch_browser_error_message")
          );
        }
      }
    });
  }
  handleCommand(command) {
    return __async(this, null, function* () {
      switch (command.method) {
        case "create-shop":
          yield this.createShop(command.item);
          break;
        case "edit-vd-name":
          yield this.changeVdName(command.item);
          break;
        case "vd-renewal":
          yield this.toPaymentRenew(command.item);
          break;
        case "vd-lock":
          try {
            if (this.vdDetail.status == "wait" || this.vdDetail.status == "configuring") {
              this.$message.error(this.$t("main.vd_not_open_message"));
              return;
            }
            yield API.post(
              `api://base.auth.pro/v1/virtual-desktops/${this.vdId}/lock`
            );
          } catch (error) {
            if (error.hasOwnProperty("response")) {
              this.$message.error(error.response.data.errors.datas[0].message);
            }
          } finally {
            this.refresh();
          }
          break;
        case "vd-un-lock":
          if (this.vdDetail.status == "wait" || this.vdDetail.status == "configuring") {
            this.$message.error(this.$t("main.vd_not_open_message"));
            return;
          }
          if (this.vdDetail.marks && this.vdDetail.marks.tags.includes("RISK_LOCK")) {
            this.$message.error(this.$t("main.vd_has_been_closed"));
            return;
          }
          try {
            let confirm = yield this.$confirm(
              this.$t("main.vd_unlock_confirm.content"),
              this.$t("main.vd_unlock_confirm.title"),
              {
                customClass: "confirm-dark",
                confirmButtonText: this.$t(
                  "main.vd_unlock_confirm.confirm"
                ),
                cancelButtonText: this.$t(
                  "main.vd_unlock_confirm.cancel"
                ),
                confirmButtonClass: "btn-main",
                cancelButtonClass: "btn-dark",
                roundButton: true
              }
            );
            yield API.delete(
              `api://base.auth.pro/v1/virtual-desktops/${this.vdId}/lock`
            );
          } catch (error) {
            if (error.hasOwnProperty("response")) {
              this.$message.error(error.response.data.errors.datas[0].message);
            }
          } finally {
            this.refresh();
          }
          break;
        case "traffic-detail":
          yield this.trafficDetail(command.item);
          break;
      }
    });
  }
  createShop(item) {
    return __async(this, null, function* () {
      this._shopFormDialog.open(null, item.id);
    });
  }
  changeVdName(item) {
    return __async(this, null, function* () {
      this._editVdNameDialog.open(item);
    });
  }
  format_login_time(time) {
    if (time === 0 || time === null) {
      return "--";
    } else {
      return DateFormat.format_login_time(DateFormat.check(time));
    }
  }
  toPaymentRenew(item) {
    return __async(this, null, function* () {
      try {
        let arr = [];
        arr.push(item.config.oldId);
        yield API.post(
          `api://base.auth/api/v7/payment/virtualdesktop-verification/renew`,
          {
            ids: arr
          }
        );
        this.$router.push({
          name: "payment",
          query: {
            style: "renew"
          },
          params: {
            item: JSON.stringify(item)
          }
        });
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  //SHOP APIS
  itmeHandleCommand(command) {
    return __async(this, null, function* () {
      switch (command.method) {
        case "choose-admin":
          yield this.chooseAdmin(command.item);
          break;
        case "edit-shop":
          yield this.editShop(command.item);
          break;
        case "delete-cache":
          this.clearCache(command.item);
          break;
        case "delete-shop":
          yield this.deleteShops([command.item]);
          break;
        case "add-additional-access":
          command.item.shopId = command.item.id;
          this._addVisitDialog.open(command.item);
          break;
      }
    });
  }
  editShop(row) {
    return __async(this, null, function* () {
      try {
        if (row.marks && row.marks.is("IS_ADMIN")) {
          this._shopFormDialog.open(row.id, row.vd.id, true);
        } else {
          this._shopFormDialog.open(row.id, row.vd.id, false);
        }
      } catch (e) {
        console.dir(e);
      }
    });
  }
  clearCache(row) {
    return __async(this, null, function* () {
      var _a, _b;
      const h = this.$createElement;
      let self = this;
      if (((_a = this.$session) == null ? void 0 : _a.permissions.any("DELETE_CACHE", "SHOW_ALL_MENUS")) || ((_b = this.$session) == null ? void 0 : _b.type) === "account") {
        this.$confirm("", this.$t("main.hint"), {
          message: h("div", void 0, [
            h(
              "div",
              {
                class: "text-content",
                style: "overflow: hidden;text-overflow: ellipsis;"
              },
              `${this.$t("main.do_you_want_to_delete", { name: row.name })}`
            ),
            h(
              "el-checkbox",
              {
                class: {
                  "ui-checkbox": true
                },
                key: Math.random(),
                domProps: {
                  checked: self.del_cookie
                },
                on: {
                  input: function(event) {
                    self.del_cookie = event;
                  }
                }
              },
              this.$t("main.at_the_same_time_delete_the_store_binding")
            )
          ]),
          confirmButtonText: this.$t("main.delete"),
          cancelButtonText: this.$t("main.cancel"),
          roundButton: true,
          type: "warning"
        }).then(() => __async(this, null, function* () {
          var _a2;
          try {
            if (this.del_cookie) {
              yield API.delete(
                `api://base.auth/api/v8/shop-cookies/${row.shopOldId}`
              );
              this.del_cookie = false;
            }
            yield API.post(`api://base.local/websockets/main`, {
              model: "delete.shop.cache",
              vd_id: row.vd.oldId,
              shop_id: row.shopOldId,
              account: (_a2 = this.$session) == null ? void 0 : _a2.account
            });
            this.$message.success(this.$t("main.delete_successful"));
            this.refresh();
          } catch (error) {
            this.del_cookie = false;
            if (error.hasOwnProperty("response")) {
              this.$message.error(error.response.data.errors.datas[0].message);
            }
          }
        })).catch((error) => {
          console.log(error);
          this.del_cookie = false;
          return;
        });
      } else {
        this.$confirm("", this.$t("main.hint"), {
          message: h("div", void 0, [
            h(
              "div",
              {
                class: "text-content",
                style: "overflow: hidden;text-overflow: ellipsis;"
              },
              `${this.$t("main.do_you_want_to_delete", { name: row.name })}`
            )
          ]),
          confirmButtonText: this.$t("main.delete"),
          cancelButtonText: this.$t("main.cancel"),
          roundButton: true,
          type: "warning"
        }).then(() => __async(this, null, function* () {
          var _a2;
          try {
            this.del_cookie = false;
            yield API.post(`api://base.local/websockets/main`, {
              model: "delete.shop.cache",
              vd_id: row.vd.oldId,
              shop_id: row.shopOldId,
              account: (_a2 = this.$session) == null ? void 0 : _a2.account
            });
            this.$message.success(this.$t("main.delete_successful"));
            this.refresh();
          } catch (error) {
            this.del_cookie = false;
            if (error.hasOwnProperty("response")) {
              this.$message.error(error.response.data.errors.datas[0].message);
            }
          }
        })).catch((error) => {
          console.log(error);
          this.del_cookie = false;
          return;
        });
      }
    });
  }
  deleteShops(rows) {
    return __async(this, null, function* () {
      let ids = [];
      for (const item of rows) {
        ids.push(item.id);
      }
      this.$confirm(
        `${this.$t("main.this_operation_will_permanently_delete_the_store", {
          name: rows[0].name
        })}<br/>
    ${this.$t("main.after_delete_message")}`,
        this.$t("main.hint"),
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: this.$t("main.delete"),
          cancelButtonText: this.$t("main.cancel"),
          roundButton: true,
          type: "warning"
        }
      ).then(() => __async(this, null, function* () {
        yield API.delete(`api://base.auth.pro/v1/shops`, {
          data: {
            shopIds: ids
          }
        });
        this.$message.success(this.$t("main.delete_successful"));
        this.refresh();
      })).catch(() => {
        return;
      });
    });
  }
  //UTIL APIS
  format_time(time) {
    if (time === 0 || time === null) {
      return "--";
    } else {
      return DateFormat.dateformatterDay(DateFormat.check(time));
    }
  }
  refresh() {
    return __async(this, null, function* () {
      var _a;
      yield this.getVdDetail();
      yield (_a = this.gridController) == null ? void 0 : _a.search();
    });
  }
  goBack() {
    this.$router.go(-1);
  }
};
__decorateClass([
  Ref("shop-bind-admin")
], VdSettingView.prototype, "_shopBindAdmin", 2);
__decorateClass([
  Ref("add-visit-dialog")
], VdSettingView.prototype, "_addVisitDialog", 2);
__decorateClass([
  Ref("edit-vd-name-dialog")
], VdSettingView.prototype, "_editVdNameDialog", 2);
__decorateClass([
  Ref("create-shop-dialog")
], VdSettingView.prototype, "_shopFormDialog", 2);
__decorateClass([
  Debounce(600)
], VdSettingView.prototype, "manageError", 1);
VdSettingView = __decorateClass([
  Component({
    components: {
      UiGrid,
      Shops,
      ExtShops,
      OsElement,
      VdAdminView,
      ShopBindAdmin,
      AddVisitDialog,
      StartupByShopBtn,
      EditVdNameDialog,
      VirtualdesktopForm,
      Question,
      ShopOnline
      // DragDialog,
    }
  })
], VdSettingView);
export {
  VdSettingView as default
};
